import fetch from 'auth/SearchInterceptor';
import docsFetch from 'auth/SearchDocsInterceptor';

const AlgoliaService = {};

AlgoliaService.getCustomers = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/customers',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getCars = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/cars',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getParts = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/parts',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getServices = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/services',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getVendors = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/vendors',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getVendors = function (data) {
  data = {
    ...data,
  };
  return fetch({
    url: 'indexes/vendors',
    method: 'get',
    params: data,
  });
};

AlgoliaService.getDocs = function (data) {
  data = {
    ...data,
  };
  return docsFetch({
    url: 'indexes/documentation_pages',
    method: 'get',
    params: data,
  });
};

export default AlgoliaService;
